
/*
    @85324 - Validação se o valor da inscrição estadual por estado é um valor válido
    conforme a especificação técnica disponível em http://www.sintegra.gov.br/insc_est.html
*/

function somaIESimples(ie, soma, peso, sub){
    for (let i = 0; i < ie.length - sub; ++i){
        soma += parseInt(ie.charAt(i)) * peso;
        --peso; 
    }
    return soma;
}

function somaIE(ie, soma, pesoInicial, pesoFinal, sub, check){
    for (let i = 0; i < ie.length - sub; ++i){
        if (i < check){
            soma += parseInt(ie.charAt(i)) * pesoInicial;
            --pesoInicial;
        }
        else {
            soma += parseInt(ie.charAt(i)) * pesoFinal;
            --pesoFinal;
        }
    }
    return soma;
}

export const validateIE = (ie, uf) => {
    if (typeof ie !== 'string') ie = ie.toString();

    let inscricaoEstadual = ie;

    ie = ie.replace(/\./g, "");
    ie = ie.replace(/\\/g, "");
    ie = ie.replace(/\-/g, "");
    ie = ie.replace(/\//g, "");

    // variáveis usadas para calcular conforme as especificações de cada estado
    let soma = 0, resto = 0, bloco = "", strIE = "", firstDigit = 0, peso = 0, pesoInicial = 0, pesoFinal = 0;
    let d = -1, d1 = -1, d2 = -1; // d's são digitos verificadores

    switch(uf){
        // AC - validação do estado do Acre
        case "AC":
            if (ie.length !== 13) return false;
            if (ie.slice(0, 2) !== '01') return false;

            // calcula o primeiro digito verificador
            d1 = 0;
            d2 = 0;
            pesoInicial = 4;
            pesoFinal = 9;
            soma = somaIE(ie, soma, pesoInicial, pesoFinal, 2, 3);
            d1 = 11 - soma % 11; 

            if (d1 == 10 || d1 == 11) d1 = 0;

            // calcula o segundo digito verificador
            soma = d1 * 2;
            pesoInicial = 5;
            soma = somaIE(ie, soma, pesoInicial, pesoFinal, 2, 4);
            d2 = 11 - (soma % 11); 

            if (d2 == 10 || d2 == 11) d2 = 0;

            bloco = d1 + "" + d2;
            return bloco === ie.substring(ie.length - 2, ie.length);

        // AL - validação do estado do Alagoas
        case "AL":
            if (ie.length !== 9) return false;
            if (ie.slice(0, 2) !== "24") return false;
            /* 
               o terceiro digito deve ser 0, 3, 5, 7 ou 8
               0 - Normal, 3- Produtor Rural, 5- Substituta
               7- Micro-Empresa ambulante, 8- Micro-Empresa
            */
            let terceiroDigito = [0, 3, 5, 7, 8];
            let checkDigito = false;

            for (const element of terceiroDigito){
                if (parseInt(ie.charAt(2)) == element){
                    checkDigito = true;
                }
            }
            if(!checkDigito) return false;

            // calcula o digito verificador
            peso = 9;
            d = 0;
            soma = somaIESimples(ie, soma, peso, 1) * 10;
            d = soma % 11;
            if (d == 10) d = 0;

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

         // AM - validação do estado do Amazonas
         case "AM":
            if (ie.length !== 9) return false;

            // calcula o digito verificador
            peso = 9;
            soma = somaIESimples(ie, soma, peso, 1);
            resto = soma % 11;

            if (soma < 11){
                d = 11 - soma;
            }else if (resto <= 1){
                d = 0;
            }else {
                d = 11 - resto;
            }

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // AP - validação do estado do Amapá            
        case "AP":
            // formato: 2 dígitos constantes (03) + 6 dígitos (empresa) + 1 dígito verificador
            if (ie.length !== 9) return false;
            if (ie.slice(0, 2) !== '03') return false;

            d1 = -1;
            d = 0;
            soma = -1;
            peso = 9;

            // ignora o dígito verificador
            let digitoEmpresa = parseFloat(ie.substring(0, ie.length - 1));
            if (digitoEmpresa >= 3017001 && digitoEmpresa <= 3019022) {
                d1 = 1; 
                soma = 9;
            }
            else if (digitoEmpresa >= 3000001 && digitoEmpresa <= 3017000) {
                d1 = 0; 
                soma = 5;
            }
            else if (digitoEmpresa >= 3019023) d1 = 0; soma = 0;

            soma = somaIESimples(ie, soma, peso, 1);
            d = 11 - soma % 11;

            if (d == 10){
                d = 0;
            }else if (d == 11) d = d1;

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // BA - validação do estado da Bahia
        case "BA":
            if (ie.length !== 9 && ie.length !== 8) return false;

            // necessário o cálculo de um módulo com base no primeiro digito da inscrição estadual
            let modulo = 10;
            // calcula o primeiro digito
            firstDigit = parseInt(ie.charAt(ie.length == 8 ? 0 : 1));
            if (firstDigit == 6 || firstDigit == 7 || firstDigit == 9) modulo = 11;            

            // calcula o segundo digito verificador
            peso = ie.length == 8 ? 7 : 8;
            soma = somaIESimples(ie, soma, peso, 2);
            resto = soma % modulo;

            if (resto == 0 || (modulo == 11 && resto == 1)){
                d2 = 0;
            }else {
                d2 = modulo - resto;
            }

            // calcula o primeiro digito verificador com base no segundo
            resto = 0;
            soma = d2 * 2;
            peso = ie.length == 8 ? 8 : 9;
            soma = somaIESimples(ie, soma, peso, 2);
            resto = soma % modulo;

            if (resto == 0 || (modulo == 11 && resto == 1)){
                d1 = 0;
            }else{
                d1 = modulo - resto;
            }

            bloco = d1 + "" + d2;
            return bloco === ie.substring(ie.length - 2, ie.length);

        // CE - validação do estado do Ceará
        case "CE":
            if (ie.length !== 9) return false;

            // cálculo do digito verificador
            soma = 0;
            peso = 9;
            d = -1;
            soma = somaIESimples(ie, soma, peso, 1); 
            d = 11 - (soma % 11);

            if(d == 10 || d == 11) d = 0;

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // ES - validação do estado do Espírito Santo
        case "ES":
            if (ie.length !== 9) return false;

            // calcula o digito verificador
            peso = 9;
            d = -1;
            soma = somaIESimples(ie, soma, peso, 1);
            resto = soma % 11;

            if (resto < 2){
                d = 0;
            }else if (resto > 1){
                d = 11 - resto;
            }

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // GO - validação do estado do Goiás
        case "GO":
            if (ie.length !== 9) return false;
            if (ie.slice(0, 2) !== '10') {
                if (ie.slice(0, 2) !== '11') {
                    if (ie.slice(0, 2) !== '15') return false;
                }
            }
            if (ie.substring(0, ie.length - 1) == "11094402"){
                if (ie.substring(ie.length - 1, ie.length) != "0"){
                    if (ie.substring(ie.length - 1, ie.length) != "1") return false;
                }
            }else{
                // calcula o digito verificador
                peso = 9;
                d = -1;
                str = "";
                soma = somaIESimples(ie, soma, peso, 1);
                resto = soma % 11;
                let faixaInicio = 10103105;
                let faixaFim = 10119997;
                strIE = ie.substring(0, ie.length - 1);
                let insc =  parseFloat(strIE);

                if(resto == 0){
                    d = 0;
                }else if (resto == 1){
                    if (insc >= faixaInicio && insc <= faixaFim){
                        d = 1;
                    }else {
                        d = 0;
                    }
                }else if (resto != 0 && resto != 1) d = 11 - resto;

                bloco = d + "" ;
                return bloco === ie.substring(ie.length - 1, ie.length);
            }

        // MA - validação do estado do Maranhão
        case "MA":
            if (ie.length !== 9) return false;
            if (ie.slice(0, 2) !== '12') return false;

            // calcula o digito verificador
            peso = 9;
            soma = somaIESimples(ie, soma, peso, 1);
            resto = soma % 11;
            d = 11 - resto;

            if (resto == 0 || resto == 1) d = 0;

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // MT - validação do estado do Mato Grosso
        case "MT":
            if (ie.length !== 11) return false;

            // calcula o digito verificador
            pesoInicial = 3;
            pesoFinal = 9;
            soma = somaIE(ie, soma, pesoInicial, pesoFinal, 1, 2);
            resto = soma % 11;
            d = 11 - resto;
            
            if (resto == 0 || resto == 1) d = 0;

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // MS - validação do estado do Mato Grosso do Sul
        case "MS":
            if (ie.length !== 9) return false;
            if (ie.slice(0, 2) !== '28') return false;

            // calcula o digito verificador
            peso = 9;
            soma = somaIESimples(ie, soma, peso, 1);
            resto = soma % 11;
            let result = 11 - resto;

            if(resto == 0){
                d = 0;
            }else if (resto > 0){
                if (result > 9){
                    d = 0;
                }else if (result < 10) d = result;
            }

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // AC - validação do estado de Minas Gerais
        case "MG":
            if (ie.length !== 13) return false;

            // iguala as casas para o cálculo
            strIE = "";
            let strX = "", strY = "", str = "", aux1 = 0, aux2 = 0;

            for (let i = 0; i < ie.length - 2; ++i){
                if (!isNaN(ie.charAt(i))){
                    if (i == 3){
                        strIE += "0";
                        strIE += ie.charAt(i);
                    }else{
                        strIE += ie.charAt(i);
                    }
                }
            }
            // calcula o primeiro digito verificador
            soma = 0;
            pesoInicial = 1;
            pesoFinal = 2;
            d1 = -1;
            for (let i = 0; i < strIE.length; ++i){
                if (i % 2 == 0){
                    str = strIE.charAt(i);
                    aux1 = parseInt(str) * pesoInicial
                    strX = aux1.toString();
                    for (let j = 0; j < strX.length; ++j) soma += parseInt(strX.charAt(j));
                }else {
                    str = strIE.charAt(i);
                    aux2 = parseInt(str) * pesoFinal;
                    strY = aux2.toString();
                    for (let j = 0; j < strY.length; ++j) soma += parseInt(strY.charAt(j));
                }
            }

            let dezenaExata = soma;
            while ((dezenaExata % 10) != 0) ++dezenaExata;
            d1 = dezenaExata - soma;

            // calcula o segundo digito verificador
            soma = d1 * 2;
            pesoInicial = 3;
            pesoFinal = 11;
            d2 = -1;
            soma = somaIE(ie, soma, pesoInicial, pesoFinal, 2, 2);
            resto = soma % 11;
            d2 = 11 - resto;

            if (resto == 0 || resto == 1) d2 = 0;

            bloco = d1 + "" + d2;
            return bloco === ie.substring(ie.length - 2, ie.length);

        // PA - validação do estado do Pará
        case "PA":
            if (ie.length !== 9) return false;
            if (ie.slice(0, 2) !== '15') return false;

            // calcula o digito verificador
            peso = 9;
            soma = somaIESimples(ie, soma, peso, 1);
            resto = soma % 11;
            d = 11 - resto;
            if (resto == 0 || resto == 1) d = 0;

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // PB - validação do estado do Paraíba
        case "PB":
            if (ie.length !== 9) return false;

            // calcula o digito verificador
            peso = 9;
            soma = somaIESimples(ie, soma, peso, 1);
            d = 11 - (soma % 11);

            if(d == 10 || d == 11) d = 0;

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // PR - validação do estado do Paraná
        case "PR":
            if (ie.length !== 10) return false;

            // calcula o primeiro digito verificador
            pesoInicial = 3;
            pesoFinal = 7;
            soma = somaIE(ie, soma, pesoInicial, pesoFinal, 2, 2);
            resto = soma % 11;
            d1 = 11 - resto;

            if (resto == 0 || resto == 1) d1 = 0;

            // calcula o segundo digito verificador
            soma = d1 * 2;
            pesoInicial = 4;
            soma = somaIE(ie, soma, pesoInicial, pesoFinal, 2, 3);
            resto = soma % 11;
            d2 = 11 - resto;

            if (resto == 0 || resto == 1) d2 = 0

            bloco = d1 + "" + d2;
            return bloco === ie.substring(ie.length - 2, ie.length);

        // PE - validação do estado do Pernambuco
        case "PE":
            if (ie.length !== 9) return false;

            // calcula do primeiro digito verificador
            strIE = ie.slice(0, 8);
            soma = 0;
            resto = 0;
            peso = 8;
            d1 = -1;
            soma = somaIESimples(strIE, soma, peso, 1);
            resto = soma % 11;

            if (resto == 1 || resto == 0){
                d1 = 0;
            }else {
                d1 = 11 - resto;
            }

            // calcula do segundo digito verificador
            soma = d1 * 2; 
            resto = 0
            peso = 9;
            d2 = -1;
            soma = somaIESimples(strIE, soma, peso, 1);
            resto = soma % 11;

            if (resto == 1 || resto == 0){
                d2 = 0;
            }else {
                d2 = 11 - resto;
            }
             bloco = "" + d1 + d2;
             return bloco === ie.substring(ie.length - 1, ie.length); 

        // PI - validação do estado do Piauí
        case "PI":
            if (ie.length !== 9) return false;

            // calcula o digito verificador
            soma = 0;
            peso = 9;
            d = -1;
            soma = somaIESimples(ie, soma, peso, 1);
            d = 11 - (soma % 11);

            if (d == 11 || d == 10) d = 0;

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // RJ - validação do estado do Rio de Janeiro
        case "RJ":
            if (ie.length !== 8) return false;

            // calcula o digito verificador
            peso = 7;
            for(let i = 0; i < ie.length - 1; ++i){
                if(i == 0){
                    soma += parseInt(ie.charAt(i)) * 2;
                } else {
                    soma += parseInt(ie.charAt(i)) * peso;
                    --peso;
                }
            }
            resto = soma % 11;
            d = 11 - resto;

            if (resto <= 1) d = 0;

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // RN - validação do estado do Rio Grande do Norte
        case "RN":
            if (ie.length !== 9 && ie.length !== 10) return false;
            if (ie.slice(0, 2) !== '20') return false;

            // calcula o digito verificador
            d = -1;
            soma = 0;
            if (ie.length == 9){
                peso = 9;
            }else {
                peso = 10;
            }
            soma = somaIESimples(ie, soma, peso, 1);
            d = (soma * 10) % 11;

            if (d == 10) d = 0;

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // RS - validação do estado do Rio Grande do Sul
        case "RS":
            if (ie.length !== 10) return false;

            // calcula o digito verificador
            strIE = ie.charAt(0);
            soma = parseInt(str);
            soma *= 2;
            peso = 9;
            d = -1;
            for(let i = 1; i < ie.length - 1; ++i){
                soma += parseInt(ie.charAt(i)) * peso;
                --peso;
            }
            d = 11 - (soma % 11);

            if (d == 10 || d == 11) d = 0;

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // RO - validação do estado de Rondônia
        case "RO":
            if (ie.length !== 14) return false;

            // calcula o digito validador
            pesoInicial = 6;
            pesoFinal = 9;
            soma = somaIE(ie, soma, pesoInicial, pesoFinal, 1, 5);
            d = 11 - (soma % 11);

            if (d ==  11 || d == 10) d -= 10;

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // RR - validação do estado de Roraima
        case "RR":
            if (ie.length !== 9) return false;
            if (ie.slice(0, 2) !== '24') return false;

            // calcula o digito verificador
            peso = 1;
            soma = somaIESimples(ie, soma, peso, 1);
            d = soma % 9;

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // SC - validação do estado de Santa Catarina
        case "SC":
            if (ie.length !== 9) return false;

            // calcula o digito verificador
            peso = 9;
            soma = somaIESimples(ie, soma, peso, 1);
            resto = soma % 11;
            d = 11 - resto;

            if (resto == 0 || resto == 1) d = 0;

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // SP - validação do estado de São Paulo
        case "SP":
            if (inscricaoEstadual.charAt(0) == 'P') ie = "P" + ie;

            if (ie.length !== 12 && ie.length !== 13) return false;

            if (ie.length == 12) {
                // calcula o primeiro digito verificador
                soma = 0;
                peso = 1;
                d1 = -1;
                strIE = "";
                for(let i = 0; i < ie.length - 4; ++i){
                    if(i == 1 || i == 7){
                        ++peso;
                        soma += parseInt(ie.charAt(i)) * peso;
                        ++peso;
                    } else {
                        soma += parseInt(ie.charAt(i)) * peso;
                        ++peso;
                    }
                }
                d1 = soma % 11;
                let strD1 = d1.toString();
                strD1 = strD1.charAt(strD1.length - 1);
                d1 = parseInt(strD1);

                // calcula o segundo digito verificador
                soma = 0;
                pesoInicial = 3;
                pesoFinal = 10;
                soma = somaIE(ie, soma, pesoInicial, pesoFinal, 1, 2);
                d2 = soma % 11;
                let strD2 = d2.toString();
                strD2 = strD2.charAt(strD2.length - 1);
                d2 = parseInt(strD2);
                d2 = d2 + "";
                return ie.substring(8, 9) != d2 || ie.substring(11, 12) != d2;
            }else {
                if (ie.charAt(0) != 'P') return false;

                strIE = ie.substring(1, 10);
                soma = 0;
                peso = 1;

                for(let i = 0; i < strIE.length - 1; ++i){
                    if(i == 1 || i == 7){
                        ++peso;
                        soma += parseInt(strIE.charAt(i)) * peso;
                        ++peso;
                    } else {
                        soma += parseInt(strIE.charAt(i)) * peso;
                        ++peso;
                    }
                }
                d1 = soma % 11;
                let strD1 = d1.toString();
                d1 = parseInt(strD1.charAt(strD1.length - 1));
                d1 = d1 + "";
                return ie.substring(9, 10) != d1;
            }

        // SE - validação do estado do Sergipe
        case "SE":
            if (ie.length !== 9) return false;

            // calcula o digito verificador
            peso = 9;
            soma = somaIESimples(ie, soma, peso, 1);
            d = 11 - (soma % 11);

            if (d == 11 || d == 10) d = 0;

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // TO - validação do estado do Tocantins
        case "TO":
            if (ie.length !== 9 && ie.length !== 11) {
                return false;
            }else if(ie.length == 9) {
                ie = ie.substring(0, 2) + "02" + ie.substring(2);
            }

            // calcula o digito verificador
            peso = 9;
            for(let i = 0; i < ie.length - 1; ++i){
                if(i != 2 && i != 3){
                    soma += parseInt(ie.charAt(i)) * peso;
                    --peso;
                }
            }
            resto = soma % 11;
            d = 11 - resto;

            if (resto < 2) d = 0

            bloco = d + "" ;
            return bloco === ie.substring(ie.length - 1, ie.length);

        // DF - validação do estado do Distrito Federal
        case "DF":
            if (ie.length !== 13) return false;

            // calcula o primeiro digito verificador
            pesoInicial = 4;
            pesoFinal = 9;
            soma = somaIE(ie, soma, pesoInicial, pesoFinal, 2, 3);

            d1 = 11 - (soma % 11);

            if (d1 == 11 || d1 == 10) d1 = 0;

            // calcula o segundo digito verificador
            soma = d1 * 2;
            pesoInicial = 5;
            soma = somaIE(ie, soma, pesoInicial, pesoFinal, 2, 4);
            d2 = 11 - (soma % 11);

            if (d2 == 11 || d2 == 10) d2 = 0;

            bloco = d1 + "" + d2;
            return bloco === ie.substring(ie.length - 2, ie.length);

        default:
            return false;
    }
};